import React from 'react';

const PRESETS = [
  { label: '3 días', days: 3 },
  { label: '7 días', days: 7 },
  { label: '15 días', days: 15 },
  { label: '30 días', days: 30 },
];

const CalendarPresets = ({ onSelect, minDate, maxDays = 365, activePreset }) => {
  const formatDateRange = (days) => {
    const start = new Date(minDate);
    const end = new Date(minDate);
    end.setDate(end.getDate() + days - 1);
    const opts = { day: '2-digit', month: 'short' };
    return `${start.toLocaleDateString('es', opts)} - ${end.toLocaleDateString('es', opts)}`;
  };

  return (
    <div className="sf-calendar-presets">
      {PRESETS.filter(({ days }) => days <= maxDays).map(({ label, days }) => (
        <button
          key={days}
          type="button"
          className={`sf-preset-btn ${activePreset === days ? 'active' : ''}`}
          onClick={() => onSelect(days)}
          title={formatDateRange(days)}
        >
          <span className="sf-preset-label">{label}</span>
          <span className="sf-preset-dates">{formatDateRange(days)}</span>
        </button>
      ))}
    </div>
  );
};

export default CalendarPresets;
